export const FETCH_MANAGER_EMAIL_BY_ID = 'FETCH_MANAGER_EMAIL_BY_ID';
export const LOAD_MANAGER_EMAIL_BY_ID = 'LOAD_MANAGER_EMAIL_BY_ID';
export const SET_MANAGER_EMAIL_BY_ID = 'SET_MANAGER_EMAIL_BY_ID';

export const loadManagerEmailById = ({ id }) => ({
  payload: { id },
  type: LOAD_MANAGER_EMAIL_BY_ID,
});
